var _desc, _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeguros(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "transparent"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "16e87491-91ad-4b58-891a-43df297f4874"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(252,255,0)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "9a39b910-90ad-4e98-86a6-0d0366cd86f3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0 0 0 0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(15.4 0 0 15.4 538.52 538.52)",
    id: "7ce850e2-2c17-4066-9634-b7698bf3a593"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "rgb(0,0,0)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(67,143,167)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    cx: 0,
    cy: 0,
    r: 35
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.37 0 0 3.37 605.26 540)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -8.04 0)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-83.2, -79.17)",
    d: "M 64.22 158.33 C 63.24 158.33 62.53 158.24 62.089999999999996 158.16000000000003 C 56.56999999999999 157.78000000000003 41.22 150.17000000000002 28.099999999999994 140.07000000000002 C 15.28 130.2 0 114.63 0 96.48 L 0 34.84 C 0 33.14 1.25 31.71 2.92 31.49 C 39.79 26.5 57.57 1.69 57.75 1.44 C 58.36 0.56 59.36 0.02 60.44 0 C 61.47 0 62.54 0.46 63.19 1.31 C 63.41 1.59 85.55 29.709999999999997 121.78999999999999 31.459999999999997 C 123.58999999999999 31.549999999999997 124.99999999999999 33.029999999999994 124.99999999999999 34.83 L 124.99999999999999 96.47 C 124.99999999999999 98.33 123.48999999999998 99.85 121.61999999999999 99.85 C 119.75 99.85 118.24 98.33999999999999 118.24 96.47 L 118.24 37.98 C 87.86 35.31999999999999 67.66 16.389999999999997 60.589999999999996 8.659999999999997 C 54.29 15.939999999999998 36.83 32.769999999999996 6.739999999999995 37.73 L 6.739999999999995 96.47 C 6.739999999999995 112.65 22.619999999999997 127.32 32.089999999999996 134.63 C 46.08 145.43 59.919999999999995 151.37 62.489999999999995 151.42 C 62.81999999999999 151.42 63.019999999999996 151.42 63.33 151.53 L 63.33 151.53 C 63.33 151.53 71.58 152.94 86.95 140.17000000000002 C 117.9 114.42000000000002 139.69 108.50000000000001 162.88 107.53000000000002 C 164.76999999999998 107.46000000000002 166.32 108.90000000000002 166.39 110.76000000000002 C 166.47 112.62000000000002 165.01999999999998 114.20000000000002 163.16 114.27000000000002 C 141.34 115.18000000000002 120.75999999999999 120.81000000000003 91.25999999999999 145.35000000000002 C 77.66999999999999 156.66000000000003 68.44999999999999 158.32000000000002 64.21 158.32000000000002 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 51.6 54.34)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-142.84, -133.51)",
    d: "M 106.42 148.77 C 105.5 148.77 104.59 148.38000000000002 103.96000000000001 147.62 C 102.82000000000001 146.26 102.99000000000001 144.23000000000002 104.35000000000001 143.09 C 104.73 142.77 113.81 135.19 127.61000000000001 128.44 C 146.05 119.42 164.12 116.3 179.88000000000002 119.41 C 181.62000000000003 119.75 182.76000000000002 121.44 182.41000000000003 123.19 C 182.07000000000002 124.92999999999999 180.37000000000003 126.06 178.63000000000002 125.72 C 143.76000000000002 118.84 108.83000000000003 147.72 108.48000000000002 148.02 C 107.88000000000002 148.53 107.14000000000001 148.77 106.41000000000003 148.77 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -28.43 -1.88)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-62.81, -77.29)",
    d: "M 84.64 113.17 L 40.980000000000004 113.17 C 37.36000000000001 113.17 34.410000000000004 110.22 34.410000000000004 106.6 L 34.410000000000004 72.64999999999999 C 34.410000000000004 69.02999999999999 37.36000000000001 66.07999999999998 40.980000000000004 66.07999999999998 L 45.43000000000001 66.07999999999998 L 45.43000000000001 60.759999999999984 C 45.43000000000001 49.009999999999984 52.25000000000001 41.40999999999998 62.81 41.40999999999998 C 73.37 41.40999999999998 80.19 48.999999999999986 80.19 60.759999999999984 L 80.19 66.07999999999998 L 84.64 66.07999999999998 C 88.26 66.07999999999998 91.21000000000001 69.02999999999999 91.21000000000001 72.64999999999998 L 91.21000000000001 106.59999999999998 C 91.21000000000001 110.21999999999998 88.26 113.16999999999999 84.64000000000001 113.16999999999999 Z M 40.99 72.5 C 40.910000000000004 72.5 40.85 72.56 40.85 72.64 L 40.85 106.59 C 40.85 106.67 40.910000000000004 106.73 40.99 106.73 L 84.65 106.73 C 84.73 106.73 84.79 106.67 84.79 106.59 L 84.79 72.64 C 84.79 72.56 84.73 72.5 84.65 72.5 L 40.99000000000001 72.5 Z M 51.87 66.07 L 73.75999999999999 66.07 L 73.75999999999999 60.74999999999999 C 73.75999999999999 49.08999999999999 66.1 47.82999999999999 62.80999999999999 47.82999999999999 C 59.51999999999998 47.82999999999999 51.859999999999985 49.08999999999999 51.859999999999985 60.74999999999999 L 51.859999999999985 66.07 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -28.55 10.52)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-62.69, -89.68)",
    d: "M 62.7 101.89 C 59.480000000000004 101.89 56.85 99.46 56.85 96.46000000000001 L 56.85 92.44000000000001 C 54.04 90.39000000000001 52.79 87.05000000000001 53.71 83.75000000000001 C 54.550000000000004 80.75000000000001 57.24 78.36000000000001 60.56 77.69000000000001 L 60.56 77.69000000000001 C 63.59 77.07000000000001 66.63 77.78000000000002 68.89 79.63000000000001 C 70.85 81.23 71.97 83.52000000000001 71.97 85.91000000000001 C 71.97 88.46000000000001 70.67999999999999 90.85000000000001 68.53 92.44000000000001 L 68.53 96.46000000000001 C 68.53 99.45 65.91 101.89000000000001 62.68 101.89000000000001 Z M 61.53 82.41 L 61.53 82.41 C 59.99 82.72999999999999 58.71 83.78 58.36 85.03999999999999 C 57.839999999999996 86.91 59.05 88.27999999999999 60.36 88.94999999999999 L 61.67 89.61999999999999 L 61.67 96.44999999999999 C 61.67 96.68999999999998 62.08 97.04999999999998 62.690000000000005 97.04999999999998 C 63.30000000000001 97.04999999999998 63.720000000000006 96.68999999999998 63.720000000000006 96.44999999999999 L 63.720000000000006 89.61999999999999 L 65.04 88.94999999999999 C 66.37 88.26999999999998 67.16000000000001 87.13 67.16000000000001 85.90999999999998 C 67.16000000000001 84.94999999999999 66.70000000000002 84.04999999999998 65.86000000000001 83.35999999999999 C 64.72000000000001 82.42999999999998 63.15000000000001 82.07999999999998 61.54000000000001 82.40999999999998 Z",
    strokeLinecap: "round"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(NaN NaN NaN NaN 0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(NaN NaN NaN NaN 0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeguros);
export default __webpack_public_path__ + "static/media/seguros.5aaea7c479d3ce24b87cd8c3c5944bca.svg";
export { ForwardRef as ReactComponent };